import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { SEARCH_COMPANY_NAMES, EPIC_ERROR } from 'Constants/redux';
import service from 'Api/service';
import { receiveCompanyNames } from 'Actions';

const SearchCompanyNamesEpic = (action$) =>
  action$.pipe(
    ofType(SEARCH_COMPANY_NAMES),
    debounceTime(500),
    switchMap(({ query }) =>
      from(
        service.get(
          `${
            import.meta.env.VITE_API_DOMAIN
          }/api/companies/search?query=${encodeURIComponent(query)}`
        )
      ).pipe(
        map((response) => receiveCompanyNames(response.data.names)),
        catchError(() => of({ type: EPIC_ERROR }))
      )
    )
  );

export default SearchCompanyNamesEpic;
